export enum OrderProductType {
  FaspexSend = "FaspexSend",
  TranscodeByProfile = "TranscodeByProfile",
  TranscodeGeneric = "TranscodeGeneric",
  DcpReferenceFileSimple = "DcpReferenceFileSimple",
  DcpReferenceFileStitched = "DcpReferenceFileStitched",
  InternalProxyTag = "InternalProxyTag",
  AntipiracyInaSignature = "AntipiracyInaSignature",
  AntipiracyYoutube = "AntipiracyYoutube",
  TranscodeComponentsLegacy = "TranscodeComponentsLegacy",
  TranscodeByProfileAndPrintToTape = "TranscodeByProfileAndPrintToTape",
  QualityCheck = "QualityCheck",
  Qualify = "Qualify",
  TranscodeGenericSingleFile = "TranscodeGenericSingleFile",
  SubtitleConverter = "SubtitleConverter",
  ManualTasks = "ManualTasks",
  TranscodeBundleByProfile = "TranscodeBundleByProfile",
  CopyDelivery = "CopyDelivery",
  ImageConverter = "ImageConverter",
  TranscodeDownscaleAsMezz = "TranscodeDownscaleAsMezz",
  SubtitleScribeProject = "SubtitleScribeProject",
  YoutubeChannelDelivery = "YoutubeChannelDelivery",
  TranscodeSequence = "TranscodeSequence",
  TranscodeNormalizer = "TranscodeNormalizer",
  TranscodeImf = "TranscodeImf",
  TranscodeDcp = "TranscodeDcp",
  DcpKdmGeneration = "DcpKdmGeneration",
  DcpTransferGlobecast = "DcpTransferGlobecast",
  ArchiveHeritageTape = "ArchiveHeritageTape",
}
